import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.167 12.1a1.667 1.667 0 1 1-.001 3.334 1.667 1.667 0 0 1 .001-3.333m9.333 0a1.667 1.667 0 1 1 0 3.335 1.667 1.667 0 0 1 0-3.335m-9.333 1.334a.334.334 0 1 0 0 .668.334.334 0 0 0 0-.668m9.333 0a.333.333 0 1 0 0 .666.333.333 0 0 0 0-.666M2.915 2.1c.31 0 .58.215.65.517L3.907 4.1h9.753c.858 0 1.493.8 1.299 1.635l-1.235 5.333a1.334 1.334 0 0 1-1.3 1.033H5.453c-.62 0-1.159-.429-1.299-1.033L2.385 3.434h-.552a.667.667 0 0 1 0-1.334zm2.537 8.668h6.974l.618-2.668H9.833a.666.666 0 0 1 0-1.333h3.334q.093.002.179.028l.315-1.36H4.217z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }